module.exports = __webpack_public_path__ + "img/img3.ae05d29f.jpg";